module.exports = __webpack_public_path__ + "static/img/12.6bd0280.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/12.png
// module id = lzu9
// module chunks = 1